module.exports = __webpack_public_path__ + "img/manual_arm.e33acd02.png";